module.exports = __webpack_public_path__ + "static/img/curieux.2efdd85.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/curieux.png
// module id = TGY7
// module chunks = 0